import ConfirmModal from '@liveauctioneers/caterwaul-components/lib/SimpleModal/ConfirmModal/ConfirmModal';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

export type TwoStepAuthenticationDeactivationModalProps = {
    onCancel: () => void;
    onDeactivate: () => void;
    show: boolean;
};

const TwoStepAuthenticationDeactivationModal = ({
    onCancel,
    onDeactivate,
    show,
}: TwoStepAuthenticationDeactivationModalProps) => {
    const { formatMessage } = useIntl();

    return (
        <ConfirmModal
            cancelText={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.deactivationModal.keepActivated',
            })}
            confirmText={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.deactivationModal.deactivate',
            })}
            onConfirm={onDeactivate}
            onDismiss={onCancel}
            show={show}
            testid="TwoStepAuthenticationDeactivationModal"
            title={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.deactivationModal.header',
            })}
            warning={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.deactivationModal.description',
            })}
        />
    );
};

export default TwoStepAuthenticationDeactivationModal;
